import { getCache, setCache } from "../persistent-cache";
import { isFacebookWebview } from "../webview/webview";

const LANDING_URL_KEY = "lan_url";

// Url example from facebook ad:
// https://meetmyage.com/lp/4/m/?utm_medium=cpc&utm_source=fb&campaignid=23850596387450227&adgroupid=23851474399230227&adid=23851474400250227&utm_campaign=FB_Tier1_Mob%2FDesk_M_7%20%E2%80%94%20Take_trial&utm_content=65_I_Fb_M_PhotoTitle&ad=65_5&source=fb&utm_term=%7B%7Bkeyword%7D%7D&fbclid=IwAR08SiBEH_BKuTURG-Y6tRg07LGnKYC-TGBg9VZ67TlS6dreqgZVRXj3WtM

export function isFacebookUrl(url: string) {
  const { searchParams } = new URL(url);
  return searchParams.has("fbclid") || searchParams.get("utm_source") === "fb";
}

export function isTaboolaUrl(url: string) {
  try {
    const { searchParams } = new URL(url);
    return (
      searchParams.has("tbclid") || searchParams.get("utm_source") === "tb"
    );
  } catch {
    return false;
  }
}

export function isTiktokUrl(url: string) {
  try {
    const { searchParams } = new URL(url);
    return searchParams.get("utm_source") === "tt";
  } catch {
    return false;
  }
}

export function isGoogleAdwUrl(url: string) {
  try {
    const { searchParams } = new URL(url);
    return searchParams.has("gclid") || searchParams.get("network") === "adw";
  } catch {
    return false;
  }
}

function isSmmUrl(url: string) {
  const { searchParams } = new URL(url);
  return (
    searchParams.get("utm_source") === "fb" &&
    ["ig", "fb_page"].includes(searchParams.get("utm_campaign") ?? "")
  );
}

export function setUrlSearchParam(url: string, key: string, value: string) {
  const actualUrl = new URL(url);
  actualUrl.searchParams.set(key, value);
  return actualUrl.href;
}

export function getLandingUrl(): string {
  let landingUrl = getCache(LANDING_URL_KEY);
  if (!landingUrl) {
    landingUrl = window.location.href;
  }

  try {
    if (isGoogleAdwUrl(landingUrl)) {
      return landingUrl;
    }

    if (isTaboolaUrl(landingUrl)) {
      return landingUrl;
    }

    if (isTiktokUrl(landingUrl)) {
      return landingUrl;
    }

    if (isSmmUrl(landingUrl)) {
      // Mark user as sus_fraud on backend.
      landingUrl = setUrlSearchParam(landingUrl, "gdx_source", "unknown");
      landingUrl = setUrlSearchParam(landingUrl, "gdx_browser", "standard");
    } else if (!isFacebookUrl(landingUrl)) {
      landingUrl = setUrlSearchParam(landingUrl, "gdx_source", "unknown");
      if (!isFacebookWebview()) {
        landingUrl = setUrlSearchParam(landingUrl, "gdx_browser", "standard");
      }
    }
  } catch (e) {
    console.log(e);
  }

  return landingUrl;
}

export function setLandingUrl(landingUrl: string): void {
  setCache(LANDING_URL_KEY, landingUrl);
}

export function isUnknownStandardUrl(url: string) {
  try {
    const { searchParams } = new URL(url);
    return (
      searchParams.get("gdx_source") === "unknown" &&
      searchParams.get("gdx_browser") === "standard"
    );
  } catch {
    return false;
  }
}
